import api from '@/services/api'

const getUserNetworks = async (userId) => {
    try {
        const resp = await api.get(`/users/${userId}`, {
            params: {
                with: 'valuers',
            },
        })
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const createNetworks = async (data) => {
    try {
        const resp = await api.post('/networks/storeMany', data)
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const getUser = async (userId) => {
    try {
        const resp = await api.get(`/users/${userId}`, {
            params: {
                filter: 'id;name;picture;role_id;manager_id;is_target_master;is_values_master',
                transform: 'role',
                with: 'ratedCommittees;eventUser;editNetworks;valuers;manager.subordinates;subordinates',
            },
        })

        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const deleteNetwork = async (networkId) => {
    try {
        return await api.delete(`/networks/${networkId}`)
    } catch (error) {
        console.error(error)
    }
}

const deleteNetworkByUsers = async (valuerId, evaluatedId) => {
    try {
        return await api.delete(`/networks/valuer/${valuerId}/evaluated/${evaluatedId}`)
    } catch (error) {
        console.error(error)
    }
}

const getQuestionnaireToEvaluate = async (questionnaireId) => {
    try {
        const resp = await api.get(`/questionnaires/${questionnaireId}`, {
            params: {
                with: 'values;key_behaviors;questionnaireHasComments;questions;scales.degrees',
            },
        })
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const getQuestionnairesAvailableToEvaluate = async (userId) => {
    try {
        const resp = await api.get(`/questionnaires/${userId}/spontaneous-questionnaires-avaliable-to-user`)
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const getQuestionnaireAllowedUsers = async (questionnaireId, currentUserId, searchName, per_page, page) => {
    try {
        const resp = await api.get(`/questionnaires/${questionnaireId}/allowed-users-to-evaluate`, {
            params: {
                orderBy: 'name',
                filter: 'id;name;picture',
                search: `name:${searchName.trim() || ''};has_value:1`,
                searchFields: 'name:like;has_value:=',
                and: 'yes',
                user_id: currentUserId,
                per_page,
                page,
            },
        })
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const sendSpontaneousEvaluation = async (data) => {
    try {
        const resp = await api.post('/evaluations/send-spontaneous-evaluation', data)
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const getQuestionnaires = async (params = {}) => {
    try {
        const resp = await api.get('/questionnaires', {
            params,
        })
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const getUsers = async (params = {}) => {
    try {
        const resp = await api.get('/users', {
            params,
        })
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const createScore = async (payload) => {
    try {
        const resp = await api.post('/scores', payload)
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const updateScore = async (id, payload) => {
    try {
        const resp = await api.put(`/scores/${id}`, payload)
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const createComment = async (payload) => {
    try {
        const resp = await api.post('/comments/create-evalution-comment', payload)
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const updateComment = async (id, payload) => {
    try {
        const resp = await api.put(`/comments/${id}/update-evalution-comment`, payload)
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const acceptEvaluation = async (id) => {
    try {
        const resp = await api.put(`evaluations/${id}/accept`)
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const declineEvaluation = async (id) => {
    try {
        const resp = await api.put(`evaluations/${id}/decline`)
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const sendEvaluation = async (id) => {
    try {
        const resp = await api.put(`evaluations/${id}/send`)
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const updateEvaluation = async (id, payload) => {
    try {
        const resp = await api.put(`evaluations/${id}`, payload)
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const getEvaluationsList = async (params = {}) => {
    try {
        const resp = await api.get('/evaluations/list', {
            params,
        })
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const getUserEvaluationsInfo = async (userId, params = {}) => {
    try {
        const resp = await api.get(`/evaluations/${userId}/info`, {
            params,
        })
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

const getQuestionnaireUserResults = async (userId, questionnaire) => {
    try {
        const resp = await api.get(`users/${userId}/evaluations-results`, {
            params: {
                questionnaire,
            },
        })
        return resp.data.data
    } catch (error) {
        console.error(error)
        throw error
    }
}

const getEvaluationsReport = async (questionnaire, list, params = {}) => {
    try {
        const resp = await api.get(`/questionnaires/${questionnaire}/report/${list}`, {
            params,
        })
        return resp.data.data
    } catch (error) {
        console.log(error)
        throw error
    }
}

const getQuestionnaireTitle = async (questionnaireId) => {
    try {
        const resp = await api.get(`/questionnaires/${questionnaireId}`, {
            params: {
                filter: 'id;title',
            },
        })
        return resp.data
    } catch (error) {
        console.log(error)
        throw error
    }
}

const getEvaluationData = async (evaluationId, params = {}) => {
    try {
        const resp = await api.get(`/evaluations/${evaluationId}/data`, {
            params,
        })
        return resp.data
    } catch (error) {
        console.error(error)
        throw error
    }
}

const deleteAllEvaluationsOfUser = async (questionnaireId, list, params = {}) => {
    try {
        return await api.delete(`/questionnaires/${questionnaireId}/evaluations/${list}`, {
            params,
        })
    } catch (error) {
        console.log(error)
        throw error
    }
}

const deleteEvaluation = async (evaluationId) => {
    try {
        return await api.delete(`/evaluations/${evaluationId}`)
    } catch (error) {
        console.log(error)
        throw error
    }
}

const getQuestionnaireUserValuers = async (evaluatedId, questionnaireId, types) => {
    const res = await api.get('/evaluations', {
        params: {
            with: 'valuer',
            filter: 'id;questionnaire_id;valuer_id;evaluated_id;type;valuer.id;valuer.name;valuer.picture',
            search: `evaluated_id:${evaluatedId};type:${types};questionnaire_id:${questionnaireId}`,
            searchFields: 'evaluated_id:=;type:in;questionnaire_id:=',
            and: 'yes',
        },
    })

    const valuers = res.data.data.map((e) => ({ ...e.valuer, type: e.type }))

    return valuers
}

export {
    getUser,
    getUsers,
    updateScore,
    createScore,
    createComment,
    updateComment,
    deleteNetwork,
    sendEvaluation,
    createNetworks,
    getUserNetworks,
    acceptEvaluation,
    updateEvaluation,
    getEvaluationData,
    deleteEvaluation,
    getQuestionnaires,
    declineEvaluation,
    getEvaluationsList,
    deleteNetworkByUsers,
    getEvaluationsReport,
    getQuestionnaireTitle,
    getUserEvaluationsInfo,
    sendSpontaneousEvaluation,
    deleteAllEvaluationsOfUser,
    getQuestionnaireToEvaluate,
    getQuestionnaireUserResults,
    getQuestionnaireUserValuers,
    getQuestionnaireAllowedUsers,
    getQuestionnairesAvailableToEvaluate,
}
